import * as Sentry from '@sentry/react'
import { useState } from 'react'

import { toastContainerSchema } from '@/@types/schemas/toast-containers'
import { showError } from '@/components/toast'
import useTranslator from '@/hooks/translation'
import { NetworkError } from '@/services/fintalk/api/types/errors/NetworkError'
import { deleteDashboard } from '@/services/fintalk/services/fintalk-backoffice/dashboards/delete'

type IdleState = {
  type: 'idle'
}
type LoadingState = {
  type: 'loading'
}

type State = IdleState | LoadingState

export function useDashboardDelete() {
  const [state, setState] = useState<State>({ type: 'idle' })
  const { getTranslation } = useTranslator()

  const deleteDashboardAction = async (
    botId: string,
    dashboardId: string,
  ): Promise<boolean> => {
    try {
      setState({ type: 'loading' })

      await deleteDashboard(botId, dashboardId)

      setState({ type: 'idle' })
      return true
    } catch (error) {
      setState({ type: 'idle' })
      if (error instanceof NetworkError) {
        showError({
          title: getTranslation('dashboards.delete.toast.networkError.title'),
          description: getTranslation(
            'dashboards.delete.toast.networkError.description',
          ),
          containerId: toastContainerSchema.Enum.BOT_LAYOUT,
        })
        return false
      }

      const eventId = Sentry.captureException(error)
      showError({
        title: getTranslation('dashboards.delete.toast.unknownError.title'),
        description:
          getTranslation('dashboards.delete.toast.unknownError.description') +
          `\nEvent ID: ${eventId}`,
        containerId: toastContainerSchema.Enum.BOT_LAYOUT,
      })
      return false
    }
  }

  return {
    state,
    deleteDashboardAction,
  }
}
